export enum ConfigCommit {
    SET_CONFIG = 'setConfig',
    SET_CURRENT_SPREADSHEET = 'setCurrentSpreadsheet',
    SET_ACCESSIBLE = 'setAccessible',
}
